import * as React from "react";

import {faceIconColor} from "@khan/auth-shared";

export const CleverIcon = ({
    disabled = false,
    ariaHidden,
}: {
    disabled?: boolean;
    ariaHidden?: boolean;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={ariaHidden}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 12.07C4 7.06 7.72 3 13.04 3C16.31 3 18.27 4.10 19.88 5.69L17.45 8.51C16.12 7.29 14.75 6.54 13.02 6.54C10.10 6.54 7.99 8.98 7.99 11.97C7.99 15.01 10.04 17.50 13.02 17.50C15.00 17.50 16.21 16.70 17.57 15.46L20 17.92C18.22 19.84 16.23 21.03 12.89 21.03C7.79 21.03 4 17.07 4 12.07Z"
                fill={fadeFn("#436CF2")}
            />
        </svg>
    );
};
